import { P } from '@sellpy/design-system-react-web'
import styled from 'styled-components'

// Determines colour of the radio button label.
const _defaultLabelColor = ({ disabled, theme }) =>
  disabled ? theme.color.grey.shade6 : theme.color.grey.shade2

// Determines colour of the radio button icon when filled, i.e. input is checked.
const _defaultFilledColor = ({ disabled, erroneous, theme }) =>
  disabled
    ? theme.color.grey.shade4
    : erroneous
    ? theme.color.red.default
    : theme.color.blue.default

export const StyledLabel = styled(P)`
  color: ${_defaultLabelColor};
  padding: ${({ $applePay }) => ($applePay ? `6px 0px` : `8px 0px`)};
  width: 100%;
  display: flex;
  align-items: center;
`

export const StyledInput = styled.input.attrs({
  type: 'radio'
})`
  --icon-radio-button: '\\E8FE';
  --icon-radio-button-filled: '\\E8FD';
  appearance: none;
  border: none;
  font-size: 24px;
  line-height: 24px;
  width: ${({ hideButton }) => (hideButton ? '8px' : '40px')};
  height: 40px;
  background-color: transparent;
  font-family: 'fontello';
  margin: 0;
  cursor: ${({ disabled }) => (disabled ? 'cursor' : 'pointer')};
  color: ${({ erroneous, theme }) =>
    erroneous ? theme.color.red.default : theme.color.grey.shade6};

  ::before {
    /* Radio button icon */
    content: var(--icon-radio-button);
    position: relative;
    visibility: ${({ hideButton }) => (hideButton ? 'hidden' : 'visible')};
    top: 8px;
    padding: 8px;
  }

  &:checked {
    color: ${_defaultFilledColor};
    ::before {
      /* Radio button icon */
      content: var(--icon-radio-button-filled);
    }
  }
`

export const RadioButtonWrapper = styled.label`
  position: relative;
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  flex-direction: column;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.color.grey.shade10 : theme.color.grey.shade9};
  border-radius: 8px;
  margin: 8px 0;
  cursor: ${({ disabled }) => (disabled ? 'cursor' : 'pointer')};
  align-items: stretch;
  min-height: 40px;
`
